<template>
  <Container>
    <Breadcrumbs />

    <div
      class="
        grid grid-cols-2 gap-15
        lg:grid-cols-3
      "
    >
      <!-- MAIN CONTENT -->
      <div class="col-span-2">
        <!-- Publisher -->
        <p
          v-if="publisher"
          class="
            mb-2 text-gray-500
            sm:mb-3
          "
        >
          {{ publisher }}
        </p>

        <div
          class="
            mb-2 flex flex-wrap items-start gap-5
            md:gap-8
          "
        >
          <!-- Date -->
          <div class="font-semibold">
            <time :datetime="page.date_start">{{ dateStart }}</time>
            <span v-if="dateStart && dateEnd" class="px-2">-</span>
            <time :datetime="page.date">{{ dateEnd }}</time>
            <p v-if="page.time_slot">
              {{ page.time_slot }}
            </p>
          </div>

          <!-- Location -->
          <div>
            <h4 class="typo-h-5 text-gray-500">
              {{ $t('location_of_event') }}
            </h4>
            <Component
              v-bind="page.event_location_link ? { href: page.event_location_link, target: '_blank'}: null"
              :is="page.event_location_link ? 'a':'p'"
              v-if="page.event_location || page.event_location_link"
              class="text-gray-500"

              :class="{'transition-colors duration-300 hover:text-red-500': page.event_location_link}"
            >
              {{ page.event_location }}
            </Component>
          </div>
        </div>

        <HeroDefault
          :data="{
            heading: page.heading,
            text: page.text,
            image: page.image,
            copyright: page.copyright,
            links: links,
            player_id_3q: page.player_id_3q,
          }"
        />

        <LoaderComponents
          v-editor-target="'main_components'"
          :components="page.main_components"
        />
      </div>

      <!-- SIDEBAR -->
      <div class="max-lg:col-span-2">
        <LoaderComponents
          v-editor-target="'sidebar_components'"
          class="space-y-7"
          :components="page.sidebar_components"
        />
      </div>
    </div>
  </Container>
</template>

<script setup lang="ts">
import type { BlueprintEventFragment } from '#gql'

const props = defineProps<{ page: Enforce<BlueprintEventFragment> }>()

const {
  t, locale, locales,
} = useI18n()

const dateStart = computed(() => {
  return formatDate(props.page.date_start)
})

const dateEnd = computed(() => {
  return formatDate(props.page.date)
})

// Merge external link with other links
const links = computed(() => {
  const externalLink = {
    link: props.page.link_external,
    link_text: t('more'),
  }

  return [
    externalLink,
    ...props.page.links,
  ]
})

const publisher = computed(() => {
  if (props.page.publisher) {
    return props.page.publisher.title
  }

  return props.page.site_attributes.find(attr => attr.key === 'title')?.value
})

function formatDate(date: string) {
  if (!date) return

  const dateObject = new Date(date)

  if (!dateObject) return

  // Find the locale in the list of available locales by code
  const localeObj = locales.value.find(site => site.code === locale.value)

  return dateObject.toLocaleDateString(localeObj?.language || 'de-CH', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  })
}
</script>
